<template>
    <a-statistic-countdown v-if="hasDeadline" :value="value" @finish="$emit('finish')" />
    <span v-else class="activity-countdown-empty">— : — : —</span>
</template>

<script>
// Presentation adapter only: a first draw may not have an expiry yet. Do not
// turn an absent deadline into an expired activity or change eligibility.
export default {
    name: 'ActivityCountdown',
    props: { value: { type: [Number, String, Date], default: '' } },
    computed: {
        hasDeadline() {
            return this.value !== '' && this.value !== null && Number.isFinite(Number(this.value))
        }
    }
}
</script>
